import { Stack } from 'expo-router'

export default function MTTLayout() {
  return <Stack screenOptions={{ headerShown: false }} />
}
